import React from 'react';
import { getScore } from '../shared/cellUtils';
import {
    MEASURE,
    MEASURES_WITHOUT_GOAL,
    MEASURES_WITH_PERCENTAGE,
} from '../../constants/reading/MeasuresConstants';
import { LONG_DASH } from '../../constants/shared/CellConstants';
import { getGoalByMeasureGradePeriod } from '../shared/filterUtils';
import { NA, NO_BREAK_SPACE } from '../../constants/shared/CommonConstants';
import { getPercentageSign } from '../shared/tableUtils';
import { getSpecificReadingGoal } from './filterUtils';
import { GRADE } from '../../constants/shared/GradesConstants';

export const getGoalReading = (
    isMeasureAvailable,
    interps,
    measure,
    grade,
    period,
    emptyContent = NO_BREAK_SPACE, // Required for goal section alignment
) => {
    if (grade === GRADE.PREKINDERGARTEN) return NA;
    const goal = getGoalByMeasureGradePeriod(
        interps,
        measure,
        grade,
        period,
        getSpecificReadingGoal(measure),
    );
    const goalText =
        isMeasureAvailable && !!goal
            ? `${goal + getPercentageSign(MEASURES_WITH_PERCENTAGE, measure)}`
            : NA;

    return MEASURES_WITHOUT_GOAL.includes(measure) ? emptyContent : goalText;
};

const getTroScore = (measure, measuresNotCompleted, isComplete) =>
    !isComplete &&
    (measuresNotCompleted.includes(measure) ? (
        <div className="infotips align-pause-icon">
            <i className="icon-amplify-pause" />
        </div>
    ) : (
        LONG_DASH
    ));

export const getReadingScore = ({
    measure,
    measuresNotCompleted = [],
    measuresWithPercentage = [],
    score,
    isComplete,
    isUnofficial,
}) =>
    measure === MEASURE.TRO
        ? getTroScore(measure, measuresNotCompleted, isComplete)
        : getScore({
              measure,
              measuresNotCompleted,
              measuresWithPercentage,
              score,
              isComplete,
              isUnofficial,
          });
